module.exports = __webpack_public_path__ + "img/embedded3.48a39ca5.png";